module.exports = __webpack_public_path__ + "img/Unidad10-3.5fd60f32.png";